<div class="basic-toggle" [ngClass]="[size, checked ? 'on' : 'off', disabled ? 'disabled' : '']">
  <button
    type="button"
    class="toggle-switch"
    role="switch"
    [attr.aria-checked]="checked"
    [attr.aria-disabled]="disabled"
    [disabled]="disabled"
    (click)="onToggleClick()"
    (keydown)="onKeyDown($event)"
  >
    <span class="knob"></span>
  </button>
  <span class="toggle-label" *ngIf="label" (click)="onToggleClick()">{{ label }}</span>
  </div>


